import { Center } from "@mantine/core";

type Props = {
  errorMessage?: string;
};

export function Error({ errorMessage }: Props) {
  return <Center h="100%">{errorMessage || "일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요."}</Center>;
}
